import { Field, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { EMPTY_LIST } from '@/lib/utils';

/**
 * Props:
 *   options   the units the chosen material is tracked in
 *   label     overrides the default wording; existing forms keep theirs
 *   disabled  locks the control once something downstream depends on it
 *   required  defaults to true; a conditionally-required unit passes false and owns the check via `rules`
 *   rules     RHF rules; only meaningful once `required` is false
 */
export const ShipmentQuantityUnitField = ({
  options = EMPTY_LIST,
  label,
  disabled = false,
  required = true,
  rules,
}) => {
  const t = useTranslations();

  return (
    <Field name="shipmentQuantityUnit" required={required} rules={rules}>
      {({ id, name, value, onChange, onBlur, status, message, required }) => (
        <Dropdown
          id={id}
          name={name}
          label={label ?? t('FORM_SHIPMENT_QUANTITY_UNIT')}
          placeholder={t('FORM_SELECT_UNIT')}
          emptyMessage={t('FORM_SELECT_MATERIAL_FIRST')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={required}
          disabled={disabled}
          options={options}
        />
      )}
    </Field>
  );
};
